<script>
    import { fly, fade } from 'svelte/transition';
    import Chip from './chip.svelte';
    import { createEventDispatcher } from 'svelte';
    import { onMount } from 'svelte';
    import { clickOutside } from '@src/utils/ui';
    import { EventEmitterInstance } from '../../../utils/event-emitter';
    import ChipPriceInfo from './chip-price-info.svelte';
    import { showBetSizeChips } from '@root/src/store/chips';

    export let items = [];
    export let selectedChipIndex;
    export let selectedChipAmount;
    export let currency;
    export let chipPrice;
    export let decimal;
    export let selectedValue;

    const dispatch = createEventDispatcher();

    onMount(() => {
        EventEmitterInstance.emit('analytics-click-change-bet-amount');
    });

    const calculatePosition = index => {
        const totalItems = items.length;
        const angle = Math.PI / (totalItems - 1);
        const radius = 150;
        const centerX = 150;
        const centerY = 150;

        const x = centerX + radius * Math.cos(Math.PI - index * angle);
        const y = centerY - radius * Math.sin(Math.PI - index * angle);

        return { x, y };
    };

    const handleClick = idx => {
        selectedChip = items[idx];
        dispatch('select-chip-size', idx);

        if (selectedValue !== selectedChip) EventEmitterInstance.emit('analytics-change-bet-amount', selectedChip);
    };

    $: selectedChip = selectedChipAmount;
</script>

<div
    class=" absolute inset-0 bottom-0 z-6000 h-full w-full bg-controls-gradient transition-all duration-150"
    transition:fade={{ duration: 150 }}
></div>
<div
    class="circle-chips-container z-6000"
    on:click_outside={() => ($showBetSizeChips = false)}
    use:clickOutside={false}
>
    <div class="absolute left-1/2 -translate-x-10 translate-y-5" transition:fly={{ y: 50, duration: 150 }}>
        <div class="h-20 w-20 rounded-full bg-[#a051ff] p-2">
            <Chip
                class="aspect-square h-full w-full text-2xl ring-2 ring-white/60"
                value={selectedChip}
                index={selectedChipIndex}
            />
        </div>
        <div class="text-white">Current chip</div>
    </div>

    <ul class="chip-items" transition:fly={{ y: 50, duration: 100 }}>
        {#each items as item, index}
            <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
            <li
                class="chip-item"
                class:active={selectedChip === item}
                style="left:{calculatePosition(index).x}px; top:{calculatePosition(index).y}px;"
                on:click={() => handleClick(index)}
            >
                <Chip class="aspect-square h-14 w-14 text-2xl" value={item} {index} />
            </li>
        {/each}
    </ul>
    <div class="absolute bottom-0 flex-nowrap text-white/50" transition:fade={{ duration: 100 }}>
        {selectedChip} chip =
        <ChipPriceInfo {currency} {selectedChip} {chipPrice} {decimal} />
    </div>
</div>

<style>
    @keyframes emerge {
        0% {
            transform: scale(0);
            opacity: 0;
        }
        100% {
            transform: scale(1);
            opacity: 1;
        }
    }

    .circle-chips-container {
        bottom: calc(var(--controls-container-height) + var(--footer-height) + 24px);
        position: absolute;
        width: 300px;
        height: 200px;

        display: flex;
        justify-content: center;
        align-items: center;
    }

    .chip-items {
        list-style: none;
        padding: 0;
        margin: 0;
        position: relative;
        width: 100%;
        height: 100%;
        animation: emerge 0.3s ease-out forwards;
    }

    .chip-item {
        position: absolute;
        transform: translate(-50%, -50%);
    }

    .active {
        border: 2px solid #ffffff9e;
        border-radius: 50%;
    }
</style>
